import { useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useHeaderButtons } from '../sharedComponents/src/Contexts/HeaderButtonsContext'
import GlobalHeader from '../sharedComponents/src/globalHeader/GlobalHeader'
import { useStoreState } from '../store/hooks'

const HeaderBar: React.FC = () => {
    const { buttons } = useHeaderButtons()
    const userData = useStoreState((state) => state.userData)
    const authHeaderRef = useRef<any>(null)
    const location = useLocation()

    return (
        <GlobalHeader
            ref={authHeaderRef}
            extraButtons={userData.state === 'logged_in' ? (buttons as Array<JSX.Element>) : []}
            Link={Link}
            pathname={location.pathname}
        />
    )
}

HeaderBar.displayName = 'HeaderBar'

export default HeaderBar
